import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=6eca2eb7&scoped=true&"
import script from "./Channels.vue?vue&type=script&lang=ts&"
export * from "./Channels.vue?vue&type=script&lang=ts&"
import style0 from "./Channels.vue?vue&type=style&index=0&id=6eca2eb7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eca2eb7",
  null
  
)

component.options.__file = "Channels.vue"
export default component.exports